import React from 'react';
import AlternativeFlightPerJourney from './AlternativeFlightPerJourney';
import { AmendJourney, Ancillaries, CombinationOffer } from '@tff/types/tff';
import AlternativeFlightFares from './AlternativeFlightFares';

interface AlternativeFlightCardProps {
  outboundJourney: AmendJourney;
  inboundJourney?: AmendJourney;
  fareOffers: CombinationOffer[] | undefined;
  selectedOffer: CombinationOffer | undefined;
  ancillaries?: Ancillaries;
  handleOfferClick: (offer: CombinationOffer) => void;
}

const AlternativeFlightCard: React.FC<AlternativeFlightCardProps> = ({
  outboundJourney,
  inboundJourney,
  fareOffers,
  selectedOffer,
  ancillaries,
  handleOfferClick,
}) => {
  const selectedOfferPjId = Object.keys(selectedOffer?.PriceClasses.Journeys!).join('-');
  const flightCardPjId = `${outboundJourney.Id}-${inboundJourney?.Id}`;

  return (
    <div
      className={`${
        selectedOfferPjId === flightCardPjId ? `tff-alternative-flights-card-selected` : `tff-alternative-flights-card`
      }`}
    >
      <div style={{ width: '50%' }}>
        <AlternativeFlightPerJourney
          journey={outboundJourney}
          isOutbound
          fareOffers={fareOffers || []}
          selectedOffer={selectedOffer}
          ancillaries={ancillaries}
        />
        {inboundJourney && (
          <AlternativeFlightPerJourney
            journey={inboundJourney}
            fareOffers={fareOffers || []}
            selectedOffer={selectedOffer}
            ancillaries={ancillaries}
          />
        )}
      </div>
      <div style={{ width: '50%' }}>
        <AlternativeFlightFares
          outboundJourney={outboundJourney}
          inboundJourney={inboundJourney}
          fareOffers={fareOffers || []}
          selectedOffer={selectedOffer}
          handleOfferClick={handleOfferClick}
        />
      </div>
    </div>
  );
};

export default AlternativeFlightCard;
